import { createRequest } from "helpers/tools";

export const sendAdjustData = async (data) => {
    return await createRequest({
        suffix: "adjust",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const adjustMapping = async (data, id) => {
    return await createRequest({
        suffix: `adjust/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getAdjustMapping = async (id) => {
    return await createRequest({
        suffix: `sources/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getAdjustTest = async (id) => {
    return await createRequest({
        suffix: `adjust/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
